import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "form__submit btn btn--fullscreen" }

import {computed, ref} from "vue";

import Card from "@/components/layout/Card.vue";
import FormInput from "@/components/forms/FormInput.vue";
import FormErrorsList from "@/components/forms/FormErrorsList.vue";

import {useI18n} from "vue3-i18n";
import {useUserService} from "@/inversify.config";
import {SucceededOrNotResponse} from "@/types/responses/succeededOrNotResponse";
import { notifyError, notifySuccess } from "@/notify";
import { Status } from "@/validation";
import {IResetMemberPasswordRequest} from "@/types/requests";
import FormTooltip from "@/components/forms/FormTooltip.vue";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminResetMemberPassword',
  props: {
    organizationId: {},
    memberId: {}
  },
  setup(__props: any) {

const props = __props;

const {t} = useI18n()
const userService = useUserService()

const currentPassword = ref<string>()
const currentPasswordInput = ref<typeof FormInput>()

const newPassword = ref<string>()
const newPasswordInput = ref<typeof FormInput>()

const newPasswordConfirmation = ref<string>()
const newPasswordConfirmationInput = ref<typeof FormInput>()

const changePasswordResponse = ref<SucceededOrNotResponse>()
let errorsMessages = computed(() => {
  if (!changePasswordResponse.value)
    return []
  let response = changePasswordResponse.value as SucceededOrNotResponse
  return response.getErrorMessages('validation.password')
})

const inputValidationStatuses:any = {};
async function handleValidation(name: string, validationStatus: Status) {
  inputValidationStatuses[name] = validationStatus.valid
}

async function showErrorMessages() {
  currentPasswordInput.value?.validateInput(currentPassword.value);
  newPasswordInput.value?.validateInput(newPassword.value);
  newPasswordConfirmationInput.value?.validateInput(newPasswordConfirmation.value);
}

async function handleSubmit() {
  await showErrorMessages();

  if (Object.values(inputValidationStatuses).some(x => x === false)) {
    notifyError(t('global.formErrorNotification'))
    return
  }

  const request = {
    newPassword: newPassword.value,
    newPasswordConfirmation: newPasswordConfirmation.value,
  } as IResetMemberPasswordRequest

  changePasswordResponse.value = await userService
      .resetMemberPassword(props.organizationId, props.memberId, request) as SucceededOrNotResponse;

  changePasswordResponse.value.succeeded
    ? notifySuccess(t('password.form.successMessage'))
    : notifyError(t('password.form.failedMessage'));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    title: _unref(t)('password.form.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "form",
        novalidate: "",
        onSubmit: _withModifiers(handleSubmit, ["prevent"])
      }, [
        (changePasswordResponse.value && !changePasswordResponse.value.succeeded && changePasswordResponse.value.errors.length > 0)
          ? (_openBlock(), _createBlock(FormErrorsList, {
              key: 0,
              title: _unref(t)('password.form.failedMessage'),
              errorsList: _unref(errorsMessages)
            }, null, 8, ["title", "errorsList"]))
          : _createCommentVNode("", true),
        _createVNode(FormTooltip, null, {
          default: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('password.form.format')), 1)
          ]),
          _: 1
        }),
        _createVNode(FormInput, {
          ref_key: "newPasswordInput",
          ref: newPasswordInput,
          modelValue: newPassword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
          label: _unref(t)('password.form.newPassword'),
          name: "newPassword",
          type: "password",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"]),
        _createVNode(FormInput, {
          ref_key: "newPasswordConfirmationInput",
          ref: newPasswordConfirmationInput,
          modelValue: newPasswordConfirmation.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPasswordConfirmation).value = $event)),
          label: _unref(t)('password.form.newPasswordConfirmation'),
          name: "newPasswordConfirmation",
          type: "password",
          onValidated: handleValidation
        }, null, 8, ["modelValue", "label"]),
        _createElementVNode("button", _hoisted_2, _toDisplayString(_unref(t)('global.save')), 1)
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})